import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function defaultLanding(role) {
  // Operator → /platform; admin & manager share the /admin shell;
  // employees → /scan. Keeps the role gate idempotent — wrong-role users
  // are always redirected to *their* home, never a broken page.
  if (role === "platform_superadmin") return "/platform";
  if (role === "admin" || role === "manager") return "/admin";
  return "/scan";
}

export function ProtectedRoute({ children, role, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-paper">
        <div className="font-mono text-sm text-muted-foreground" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  // Allow either a single `role` (legacy) or a `roles` array for shared shells.
  const allowed = roles ? roles : (role ? [role] : null);
  if (allowed && !allowed.includes(user.role)) {
    return <Navigate to={defaultLanding(user.role)} replace />;
  }
  return children;
}
